import { Bounce, toast } from "react-toastify";

const SuccessAlert = (code, message) => {
//   if(code === 200){
    toast.success(message, {
        position: "top-right",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        transition: Bounce,
      })
//   }
  
};

export default SuccessAlert;
